import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "charts-table charts-comparison-table" }
const _hoisted_2 = { class: "charts-comparison-table__header" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "charts-comparison-table__gradient"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
      _createElementVNode("col", { span: "1" }),
      _createElementVNode("col", { span: "5" })
    ], -1)),
    _createElementVNode("header", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
        return (_openBlock(), _createElementBlock("p", { key: index }, [
          _createTextVNode(_toDisplayString(header.title) + " ", 1),
          (header.tooltip)
            ? (_openBlock(), _createBlock(_component_ElTooltip, {
                key: 0,
                placement: "top",
                enterable: false,
                "popper-class": "charts-comparison-table__tooltip-popper el-abaca-tooltip"
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(header.tooltip), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_PxIcon, {
                    size: 14,
                    name: "question"
                  })
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("main", {
      ref: "chartsTable",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkTableScroll && _ctx.checkTableScroll(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "charts-comparison-table__rows"
        }, [
          _createElementVNode("div", { title: label }, [
            _createElementVNode("span", {
              style: _normalizeStyle({
              backgroundColor: _ctx.colors[index],
            })
            }, null, 4),
            _createElementVNode("p", null, _toDisplayString(label), 1)
          ], 8, _hoisted_3),
          _createElementVNode("p", null, _toDisplayString(_ctx.data[index].absoluteValues[0]), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.data[index].data[0]) + "%", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.data[index].absoluteValues[1] >= 0
              ? _ctx.data[index].absoluteValues[1]
              : "-"), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.data[index].data[1] >= 0 ? `${_ctx.data[index].data[1]}%` : "-"), 1),
          (_ctx.data[0].absoluteValues.length <= 1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString("-")))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "charts-comparison-table__change",
                innerHTML: _ctx.getDifference(_ctx.data[index].data[1], _ctx.data[index].data[0])
              }, null, 8, _hoisted_5))
        ]))
      }), 128))
    ], 544),
    (_ctx.isGradientVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}